import { motion } from 'framer-motion';

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className = '', y = 44 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = '', lineClassName = '', baseDelay = 0.2 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span className="mask-line" key={i}>
          <motion.span
            initial={{ y: '110%' }}
            animate={{ y: '0%' }}
            transition={{ duration: 1.1, delay: baseDelay + i * 0.14, ease: EASE }}
            className={lineClassName}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
